import axios from 'axios';
import API_URL from '../functions/API_URL';

/**
 * CSRF token cache — avoids fetching a new token for every POST request.
 * Token is reused across requests and refreshed on 403 errors.
 */
let _csrfToken = null;
let _csrfFetchPromise = null;

async function getCsrfToken(forceRefresh = false) {
    // Return cached token if available
    if (_csrfToken !== null && !forceRefresh) {
        return _csrfToken;
    }

    // If already fetching, wait for that request instead of making a new one
    if (_csrfFetchPromise) {
        return _csrfFetchPromise;
    }

    _csrfFetchPromise = axios({
        method: 'GET',
        url: `${API_URL}/csrfToken`,
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    }).then(res => {
        _csrfToken = res.data._csrf;
        _csrfFetchPromise = null;
        return _csrfToken;
    }).catch(err => {
        _csrfFetchPromise = null;
        throw err;
    });

    return _csrfFetchPromise;
}

/**
 * Request ajax request to api action
 * @param {api url} url
 * @param {api method, eg: GET, POST, PUT} method
 * @param {api data, if need send to api} data
 * @param {callback function, if need to do any action after api response} callback
 */
export default async function callApi(url, method, data = {}, callback = null) {
    if (method !== 'GET') {
        data = (!data) ? data = {} : data;
        data['_csrf'] = await getCsrfToken();
    }

    const request = await axios({
        method: method,
        url: `${API_URL}/${url}`,
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        data: data,
        params: method === 'GET' ? data : ''
    }).then(function (res) {
        return res.data;
    }).then(res => {
        if (callback !== null) {
            callback(res);
        }
        return res;
    }).catch(async function (error) {
        if (typeof error.response !== 'undefined' && error.response.status === 403) {
            console.log("403 occurs");

            // Refresh CSRF token and retry
            if (method !== 'GET') {
                data['_csrf'] = await getCsrfToken(true);
            }

            const request = await axios({
                method: method,
                url: `${API_URL}/${url}`,
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                data: data
            }).then(function (res) {
                return res.data;
            }).then(res => {
                if (callback !== null) {
                    callback(res);
                }
                return res;
            }).catch(function (error) {
                if (callback !== null) {
                    callback(error.response.data);
                }
            });
            return request;

        }
        if (callback) {
            callback(error.response.data);
        }
        return error.response;
    });
    return request;
}